var render = function render(){var _vm=this,_c=_vm._self._c;return _c('auth-layout',{attrs:{"isPlain":true,"progress":0,"isProgressBarHidden":true}},[_c('common-page-header',{staticStyle:{},attrs:{"heading":_vm.$t('pages.auth.verify_email.activating')}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }